"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.opticPalette = void 0;

/**
 * A Palette of colors for data visualizations
 */
var opticPalette = {
  optic10: '#E2F1E7',
  optic30: '#CAE7D2',
  optic60: '#9CD6AA',
  optic: '#5DBE75',
  opticDark: '#22973F',
  opticDarkest: '#0A6A21'
};
exports.opticPalette = opticPalette;